import React from "react";
import { useEffect } from "react";
import { useForm } from "../../useForm";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import TextArea from "../../../controls/TextArea";
import { ColorPicker } from "primereact/colorpicker";

const initialFValues = {
  name: "",
  description: "",
  is_permanent: 0,
  color: "",
};

export default function ProcessStatusForm(props: any) {
  const { index, status, setOpen, actionCall, isEdit } = props;

  const { values, setValues, handleInputChange } = useForm(
    initialFValues,
    false,
  );
  const { submitting, runSubmit } = useSlideOverSubmit();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    runSubmit(async () => {
      if (isEdit) {
        await actionCall(status, values, index);
      } else {
        await actionCall(values);
      }
    });
  };

  useEffect(() => {
    if (isEdit && status) {
      // normalize is_permanent to 0/1 so checkbox reflects correct state
      setValues({
        ...status,
        is_permanent: Number(status.is_permanent) ? 1 : 0,
      });
    }
  }, [status, setValues, isEdit]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit ? "Edit " + status?.name : "Add new process status"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div>
            <div className="mt-2">
              <Input
                label="Name"
                name="name"
                onChange={handleInputChange}
                value={values.name}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <div className="mt-4">
                <TextArea
                  label="Description"
                  name="description"
                  onChange={handleInputChange}
                  value={values.description}
                  labelOn={true}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                />
              </div>

              <div className="mt-4">
                <label
                  htmlFor="is_permanent"
                  className="block text-sm text-gray-700 mb-2"
                >
                  Permanently assign this status to products
                </label>
                <div className="flex items-center">
                  <input
                    id="is_permanent"
                    name="is_permanent"
                    type="checkbox"
                    checked={Number(values.is_permanent) === 1}
                    onChange={(e) =>
                      // useForm expects event.target.value; convert checked -> 1/0
                      handleInputChange({
                        target: {
                          name: "is_permanent",
                          value: e.target.checked ? 1 : 0,
                        },
                      } as any)
                    }
                    className="h-4 w-4 text-main-purple border-gray-300 rounded"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="color"
                  className="block text-sm font-medium text-gray-900"
                >
                  Color
                </label>
                <div className="mt-2 flex items-center space-x-3">
                  <ColorPicker
                    id="color"
                    value={values.color || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: { name: "color", value: e.value },
                      } as any)
                    }
                    format="hex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
